import { createContext } from "react";

export const BatchEventModalContext = createContext();
